import {getFCP, getLCP, getCLS, getTTFB, getFID} from 'web-vitals';

const codeableWebVitals = {

	sendWebVitals: function () {
		getFCP(codeableWebVitals.sendWebVitalsEvents);
		getLCP(codeableWebVitals.sendWebVitalsEvents);
		getCLS(codeableWebVitals.sendWebVitalsEvents);
		getTTFB(codeableWebVitals.sendWebVitalsEvents);
		getFID(codeableWebVitals.sendWebVitalsEvents);
	},

	getSelector: function (node, maxLen = 100) {
		let sel = '';
		try {
			while (node && node.nodeType !== 9) {
				const part = node.id ? '#' + node.id : node.nodeName.toLowerCase() + (
					(node.className && node.className.length) ?
						'.' + Array.from(node.classList.values()).join('.') : '');
				if (sel.length + part.length > maxLen - 1) return sel || part;
				sel = sel ? part + '>' + sel : part;
				if (node.id) break;
				node = node.parentNode;
			}
		} catch (err) {
			// Do nothing...
		}
		return sel;
	},

	getLargestLayoutShiftEntry: function (entries) {
		return entries.reduce((a, b) => a && a.value > b.value ? a : b);
	},

	getLargestLayoutShiftSource: function (sources) {
		return sources.reduce((a, b) => {
			return a.node && a.previousRect.width * a.previousRect.height >
			b.previousRect.width * b.previousRect.height ? a : b;
		});
	},

	mapWebVitalsCategory: function (name) {
		return `web_vitals_${name}`
	},

	fetchWebVitalsData: function ({name, delta, id, entries}) {
		let webVitalInfo = '(not set)';
		// Set a custom dimension for more info for any CVW breaches
		// In some cases there won't be any entries (e.g. if CLS is 0,
		// or for LCP after a bfcache restore), so we have to check first.
		if (entries.length) {
			if (name === 'LCP') {
				const lastEntry = entries[entries.length - 1];
				webVitalInfo = codeableWebVitals.getSelector(lastEntry.element);
			} else if (name === 'FID') {
				const firstEntry = entries[0];
				webVitalInfo = codeableWebVitals.getSelector(firstEntry.target);
			} else if (name === 'CLS') {
				const largestEntry = codeableWebVitals.getLargestLayoutShiftEntry(entries);
				if (largestEntry && largestEntry.sources && largestEntry.sources.length) {
					const largestSource = codeableWebVitals.getLargestLayoutShiftSource(largestEntry.sources);
					if (largestSource) {
						webVitalInfo = codeableWebVitals.getSelector(largestSource.node);
					}
				}
			}
		}

		let dataSaver;
		let effectiveType;
		let deviceMemory;
		if ('connection' in navigator) {
			dataSaver = navigator.connection.saveData;
			effectiveType = navigator.connection.effectiveType;
			deviceMemory = navigator.deviceMemory
		}

		const data = {
			"type": "track",
			"event": codeableWebVitals.mapWebVitalsCategory(name),
			"properties": {
				"score": Math.round(name === 'CLS' ? delta * 1000 : delta),
				"metric_information": webVitalInfo,
				"effective_connection": effectiveType,
				"data_saver_enabled": dataSaver,
				"device_memory": deviceMemory,
				"unique_id": id
			}
		}

		return data;
	},

	sendWebVitalsEvents: function ({name, delta, id, entries}) {

		const data = codeableWebVitals.fetchWebVitalsData({name, delta, id, entries})

		codeableWebVitals.sendWebVitalsSegmentEvents(data);
		codeableWebVitals.sendWebVitalsGAEvents(data);

	},

	sendWebVitalsGAEvents: function (data) {
		if ("function" !== typeof ga) {
			return;
		}

		ga('send', 'event', {
			eventCategory: 'Web Vitals',
			eventAction: data.event,
			// The `id` value will be unique to the current page load. When sending
			// multiple values from the same page (e.g. for CLS), Google Analytics can
			// compute a total by grouping on this ID (note: requires `eventLabel` to
			// be a dimension in your report).
			eventLabel: data.properties.unique_id,
			// Google Analytics metrics must be integers, so the value is rounded.
			// For CLS the value is first multiplied by 1000 for greater precision
			// (note: increase the multiplier for greater precision if needed).
			eventValue: data.properties.score,
			// Use a non-interaction event to avoid affecting bounce rate.
			nonInteraction: true,
			// Use `sendBeacon()` if the browser supports it.
			transport: 'beacon',

			// OPTIONAL: any additional params or debug info here.
			// See: https://web.dev/debug-web-vitals-in-the-field/
			// dimension1: '...',
			// dimension2: '...',
			dimension2: data.properties.metric_information,
			dimension3: data.properties.effective_connection,
			dimension4: data.properties.data_saver_enabled,
			dimension5: data.properties.device_memory,
			// ...
		});
	},

	sendWebVitalsSegmentEvents: function (data) {
		window.analytics.track(data.event, data.properties);
	}
}


window.addEventListener('DOMContentLoaded', (event) => {
	const script = document.querySelector("#segment-analytics");
	if (script) {
		script.addEventListener('load', function () {
			codeableWebVitals.sendWebVitals();
		})
	}
})
